import { ErrorHandler, NgModule, inject } from '@angular/core';
import { ApmErrorHandler, ApmModule, ApmService } from '@elastic/apm-rum-angular';
import { BrowserModule } from '@angular/platform-browser';
import { IrisUserService } from '@iris/common/services/user.service';
import { IrisEnvironmentService } from '@iris/common/services/environment.service';
import { take, tap } from 'rxjs/operators';
import { ApmBase } from '@elastic/apm-rum';
import { InteractionTrackingService } from '@iris/common/modules/rum/interaction-tracking.service';

@NgModule({
  imports: [ApmModule, BrowserModule],
  providers: [ApmService, {
    provide: ErrorHandler,
    useClass: ApmErrorHandler,
  }],
})
export class RumIntegrationModule {
  private readonly apm: ApmBase;

  constructor() {
    const interactionTrackingService = inject(InteractionTrackingService);
    const apmService = inject(ApmService);
    const userService = inject(IrisUserService);
    const envService = inject(IrisEnvironmentService);

    const irisEnv = envService.env;

    if (irisEnv.rumActivated) {
      this.apm = apmService.init({
        serviceName: irisEnv.instanceName,
        environment: irisEnv.rumEnvironment,
        serverUrl: irisEnv.rumUrl,
        serviceVersion: irisEnv.version,
        logLevel: irisEnv.rumLogLevel,
        disableInstrumentations: ['click'],
      });

      userService.me$.pipe(
        take(1),
        tap(user => {
          this.apm.setUserContext({
            id: `${irisEnv.instanceId}-${user.id}`,
          });

          this.apm.setCustomContext({
            accountType: user.accountType,
            administrator: user.isAdmin,
            version: irisEnv.version,
            instanceId: irisEnv.instanceId,
            internal: user.isInternal,
            be: user.org?.be,
            di: user.org?.di,
            fco: user.org?.fco,
            gr: user.org?.gr,
            ld: user.org?.ld,
            ub: user.org?.ub,
            vss: user.org?.vss,
            syncObjId: user.syncObjId,
          });
        }),
      ).subscribe();

      interactionTrackingService.initClickTracking();
    }
  }
}
